<template>
    <Section class="bg-white">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>Privacy Policy</h2>
                <p class="mb-4 pb-3">How we store your datas and we protect our users ?</p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-10 offset-1">
<Markdown>
#### INTRODUCTION
Welcome to the Garena website run by Garena Online Private Limited and its affiliates and related corporations (individually and collectively, "Garena", "we", "us" or "our"). Garena takes its responsibilities under applicable privacy laws and regulations ("Privacy Laws") seriously and is committed to respecting the privacy rights and concerns of all users of our Garena website (the "Site") (we refer to the Site and the services we provide as described in our Site collectively as the "Services"). We recognize the importance of the personal data you have entrusted to us and believe that it is our responsibility to properly manage, protect and process your personal data. This Privacy Notice (“Privacy Notice” or “Notice”) is designed to assist you in understanding how we collect, use, disclose and/or process the personal data you have provided to us and/or possess about you, whether now or in the future, as well as to assist you in making an informed decision before providing us with any of your personal data. This Privacy Notice is also designed to assist our users who live in the European Union (the “EU”) to understand their applicable data privacy rights that exist under the EU's General Data Protection Regulation when they use the Services. Please read this Privacy Notice carefully. If you have any questions regarding this information or our privacy practices, please see the section entitled "Questions, Concerns or Complaints? Contact Us" at the end of this Privacy Notice.

"Personal Data" or "personal data" means data, whether true or not, about an individual who can be identified from that data, or from that data and other information to which an organisation has or is likely to have access. Common examples of personal data could include name, identification number and contact information.

By using the Services, registering for an account with us, visiting our website, or accessing the Services, you acknowledge and agree that you accept the practices, requirements, and/or policies outlined in this Privacy Notice, and you hereby consent to us collecting, using, disclosing and/or processing your personal data as described herein.

IF YOU DO NOT CONSENT TO THE PROCESSING OF YOUR PERSONAL DATA AS DESCRIBED IN THIS PRIVACY NOTICE, PLEASE DO NOT USE OUR SERVICES OR ACCESS OUR WEBSITE. If we change our Privacy Notice, we will post those changes or the amended Privacy Notice on our website. We reserve the right to amend this Privacy Notice at any time.
</Markdown>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-lg-10 offset-1 py-5">
                <Disqus />
            </div>
        </div>
    </Section>
</template>

<script>
import Section from '../components/Section'
import Markdown from '../components/Markdown'
import Disqus from '../components/Disqus'

export default {
    components: {
        Section,
        Markdown,
        Disqus
    },
    mounted()
    {
    }
}
</script>

<style scoped>

</style>

